import Notification from './Notification';

export default class Util {
	static isValidCharPassword(value) {
		return !!value.match(/^[0-9a-zA-Z!-/:-@?[-`{-~]+$/);
	}
	
	static urlSearchGoogleMap(value) {
		return 'https://www.google.com/maps/search/?api=1&query=' + value;
	}
	
	static updateFail(store, response, callback) {
		let notification = null;
		if (!response) {
			notification = Notification.error('通信に失敗しました', 'notificationCreateData');
		} else {
			switch(response.status) {
			case 400:
			case 404:
			case 500:{
				notification = Notification.error('更新に失敗しました', 'notificationCreateData');
				break;
			}
			case 401:{
				notification = Notification.error('認証に失敗しました', 'notificationCreateData');
				if (callback[401])
					callback[401]();
				break;
			}
			case 409:{
				notification = Notification.error('操作を取り消しました\nやり直してください', 'notificationCreateData');
				if (callback[409])
					callback[409]();
				break;
			}
			default :
				notification = Notification.error('通信に失敗しました', 'notificationCreateData');
				break;
			}
		}
		store.commit('addNotification', notification);
	}
	
	static getUTCFromYMDHMS(exp) {
		return Date.UTC(exp.slice(0,4), exp.slice(4,6)-1, exp.slice(6,8), exp.slice(8,10), exp.slice(10,12), exp.slice(12,14));
	}

	static async chunkSplitPromiseAll(items, callback) {
		let i, j, k, chunk_size = 5;

		for (i=0,j=items.length; i<j; i+=chunk_size) {
			let chunk = [];
			for (k=i; k < i + chunk_size; k++) {
				if (items[k] !== undefined)
					chunk.push(items[k]);
			}
			await Promise.all(chunk.map(callback));
		}
	}
	
	static replaceEscapeString(str) {
		return new RegExp(str.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'));
	}
	
	static isiOS() {
		let ua = navigator.userAgent;
		let isiPad = ua.indexOf('iPad') > -1 || (ua.indexOf('Macintosh') > -1 && 'ontouchend' in document);
		
		return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || isiPad;
	}
	
	static onWindowResize(callback) {
		if (Util.isiOS()) {
			setTimeout(() => {
				let app = document.getElementsByClassName('application--wrap')[0];
				app.style.minHeight = window.innerHeight + 'px';
				if (callback !== undefined)
					callback();
			}, 800);
		} else {
			if (callback !== undefined)
				callback();
		}
	}
}
